var imgSource = "img-ao";

var Resource = {
  bookingCheck1: require(`@/${imgSource}/booking_check1.png`),
  bookingCheck2: require(`@/${imgSource}/booking_check2.png`),
  buttonCheckin: require(`@/${imgSource}/button_checkin.png`),
  buttonCheckout: require(`@/${imgSource}/button_checkout.png`),
  buttonReload: require(`@/${imgSource}/button_reload.png`),
  headerInfo: require(`@/${imgSource}/header_Info.png`),
  headerBg: require(`@/${imgSource}/header_bg.png`),
  headerHome: require(`@/${imgSource}/header_home.png`),
  homeCheckinNow: require(`@/${imgSource}/home_checkin-now.png`),
  homeCheckinWait: require(`@/${imgSource}/home_checkin-wait.png`),
  homeImasugu: require(`@/${imgSource}/home_imasugu.png`),
  homeNoSchedule: require(`@/${imgSource}/home_no-schedule.png`),
  iconBack: require(`@/${imgSource}/icon_back.png`),
  iconClock: require(`@/${imgSource}/icon_clock.svg`),
  iconClock2: require(`@/${imgSource}/icon_clock2.png`),
  iconClock3: require(`@/${imgSource}/icon_clock3.png`),
  iconClock3On: require(`@/${imgSource}/icon_clock3_on.png`),
  iconDoor: require(`@/${imgSource}/icon_door.svg`),
  iconMember: require(`@/${imgSource}/icon_member.svg`),
  iconPerson: require(`@/${imgSource}/icon_person.svg`),
  loginArrow: require(`@/${imgSource}/login_arrow.png`),
  loginMail: require(`@/${imgSource}/login_mail.png`),
  loginIcon: require(`@/${imgSource}/login_icon.png`),
  resultDoor: require(`@/${imgSource}/result_door.png`),
  resultDoorOn: require(`@/${imgSource}/result_door_on.png`),
  roomCheck: require(`@/${imgSource}/room_check.png`),
};
module.exports = Resource;
